import type { ResourcesConfig } from 'aws-amplify';
import { AppDispatch } from '../store/store';

export const globals: { awsConfig?: ResourcesConfig; dispatch?: AppDispatch } =
  {}; // populated in App.tsx so apiAccess.js can reach dispatch at runtime
